import { allowBackNavigationEvent, resetBackNavigationEvent } from '@bifrost/web-components';
/**
 * Block root URLs and special flows back navigation
 */
const blockBackNavigation = new Set([
    /* Landing onboarding */
    '/landing/onboarding',
    '/landing/onboarding/app',
    '/landing/onboarding/home',
    '/landing/onboarding/control',
    /* Home onboarding */
    '/home/welcome',
    '/home/welcome/device',
    '/home/welcome/service',
    '/home/welcome/play',
    /* Home tabs */
    '/home/devices',
    '/home/groups',
    /* Root url */
    '/',
    '/landing',
    '/home',
    '/services',
    '/play',
    '/devices',
    '/profile',
]);
const isBackNavigationAllowed = (pathname) => {
    return !blockBackNavigation.has(pathname);
};
const onBeforeRoutingEvent = (event) => {
    const singleSpaEvent = event;
    const { newUrl } = singleSpaEvent.detail;
    const { pathname } = new URL(newUrl);
    const canNavigateBack = isBackNavigationAllowed(pathname);
    window.bifrostNative?.setCanNavigateBack?.(canNavigateBack);
};
const onAllowBackNavigation = () => {
    window.bifrostNative?.setCanNavigateBack?.(true);
};
const onResetBackNavigation = () => {
    const canNavigateBack = isBackNavigationAllowed(location.pathname);
    window.bifrostNative?.setCanNavigateBack?.(canNavigateBack);
};
/**
 * 1. URL navigation should evaluate isBackNavigationAllowed
 * 2. Opening dialog should allow back navigation
 * 3. Closing dialog should evaluate isBackNavigationAllowed
 */
if (window.bifrostNative?.capabilities.includes('backNavigation')) {
    window.addEventListener('single-spa:before-routing-event', onBeforeRoutingEvent);
    window.addEventListener(allowBackNavigationEvent, onAllowBackNavigation);
    window.addEventListener(resetBackNavigationEvent, onResetBackNavigation);
}
